import { render, staticRenderFns } from "./goodsMaintenance.vue?vue&type=template&id=055c415e&scoped=true"
import script from "./goodsMaintenance.vue?vue&type=script&lang=js"
export * from "./goodsMaintenance.vue?vue&type=script&lang=js"
import style0 from "./goodsMaintenance.vue?vue&type=style&index=0&id=055c415e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c415e",
  null
  
)

export default component.exports